import { render, staticRenderFns } from "./UploadDownloadDN.vue?vue&type=template&id=451e8779&"
import script from "./UploadDownloadDN.vue?vue&type=script&lang=js&"
export * from "./UploadDownloadDN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports